import { render, staticRenderFns } from "./robotSelectedSetup.vue?vue&type=template&id=4adf624e&scoped=true&"
import script from "./robotSelectedSetup.vue?vue&type=script&lang=js&"
export * from "./robotSelectedSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotSelectedSetup.vue?vue&type=style&index=0&id=4adf624e&lang=less&scoped=true&"
import style1 from "./robotSelectedSetup.vue?vue&type=style&index=1&id=4adf624e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf624e",
  null
  
)

export default component.exports